import React from 'react'
import Sqaure from '../../../assets/img/About-Images/sqaure.png'
import './real-home.scss'
import useFetch from '../../../Hooks/useFetch'
import { Fade } from 'react-reveal'

export default function RealHome(props) {
  // console.log(data?.[0].Realhome.card.paragraph)
  return (
    <div id='real-home'>
      <div className='rl-container'>
        {/* <img className="picture-div" src={Sqaure} alt="square" /> */}
        <div className='before-div'></div>
        <Fade left>
          <div className='text-div'>
            <h2>{props.title}</h2>
            <p>{props.desc}</p>
          </div>
        </Fade>
      </div>
    </div>
  )
}
